import { Fragment, useEffect, useState, useContext, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import AttendeeCard from "./AttendeeCard";
import AuthContext from "../../../../auth/AuthContext";
import AssessmentService from "../../../../services/AssessmentService";
import { useLocation } from "react-router-dom";
import { useBreadcrumb } from "../../../../context/BreadcrumbContext";

const AssessmentMCQAttendees = () => {
  const navigate = useNavigate();
  const { assessmentId } = useParams();
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const { setDynamicLabels } = useBreadcrumb();
  const [loading, setLoading] = useState(true);
  const [attendees, setAttendees] = useState([]);

  

useEffect(() => {
  const assessmentName = location.state?.assessmentName;

  if (assessmentName) {
    setDynamicLabels(prev => ({
      ...prev,
      [assessmentId]: assessmentName
    }));
  }
}, [assessmentId, location.state, setDynamicLabels]);

useEffect(()=>{
    const assessmentAccess = authContext.getPermissions("assessmentsmaster");
        if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
            navigate("/");
        }
      },[authContext, navigate]);

const fetchAttendees = useCallback(async () => {
  try {
    setLoading(true);

    const response = await AssessmentService.GetAssessmentAttendees(
      50,
      0,
      assessmentId,
      "",
      authContext
    );

    const results = response?.data?.results || [];

const mappedAttendees = results.map((item) => {
  const percentage = item.totalQuestions
    ? Math.round((item.correctAnswers / item.totalQuestions) * 100)
    : 0;

  return {
    id: item.id,
    userId: item.userId,
    gender: item.gender,
    attendeeName: item.attendeeName || "Unknown",

    isExamCompleted: item.isExamCompleted,
    score: item.score,
    confidentScore: item.confidentScore,
    totalQuestions: item.totalQuestions,
    correctAnswers: item.correctAnswers,
    graceMarks: item.graceMarks,

    percentage,  
  };
});


    setAttendees(mappedAttendees);
  } catch (error) {
    console.error("Error fetching attendees:", error);
    setAttendees([]);
  } finally {
    setLoading(false);
  }
}, [assessmentId, authContext]);


useEffect(() => {
  fetchAttendees();
}, [fetchAttendees]);

const onCardClick = (attendeeId, attendeeName) => {
  navigate(
    `/masters-assessments/${assessmentId}/attendees/${attendeeId}`,
    {
      state: { attendeeName }
    }
  );
};
  

  return (
    <Fragment>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pt-3">
        {loading
          ? Array.from({ length: 6 }).map((_, idx) => (
              <div
                key={idx}
                className="
                  bg-white dark:bg-slate-900
                  rounded-xl shadow p-4
                "
              >
                <div className="flex items-center gap-4">
                  <Skeleton
                    shape="circle"
                    size="6rem"
                    className="!bg-slate-200 dark:!bg-slate-700"
                  />

                  <div className="flex-1 space-y-3">
                    <Skeleton
                      width="70%"
                      height="1.1rem"
                      className="!bg-slate-200 dark:!bg-slate-700"
                    />
                    <Skeleton
                      width="90%"
                      height="0.9rem"
                      className="!bg-slate-200 dark:!bg-slate-700"
                    />
                    <Skeleton
                      width="80%"
                      height="0.9rem"
                      className="!bg-slate-200 dark:!bg-slate-700"
                    />
                  </div>

                  <Skeleton
                    shape="circle"
                    size="5.5rem"
                    className="!bg-slate-200 dark:!bg-slate-700"
                  />
                </div>
              </div>
            ))
          : attendees.map((attendee) => (
              <AttendeeCard
                key={attendee.id}
                id={attendee.id}
                data={attendee}
                clickHandler={onCardClick}
              />
            ))}
      </div>

      {!loading && attendees.length === 0 && (
        <div className="text-center text-gray-500 mt-10">
          No data available...
        </div>
      )}
    </Fragment>
  );
};

export default AssessmentMCQAttendees;
